import { call, put, takeLatest, takeEvery } from 'redux-saga/effects'
import { toast } from 'react-toastify'

import { UserActions } from 'lmcv/redux/modules/user'
import * as service from 'lmcv/services/coupon'

import { Constants, Actions } from '.'

function * getById ({ id, category, active }) {
  try {
    const result = yield call(service.getCoupon, id, category, active)

    yield put(Actions.getComplete(result.data))
  } catch (e) {
    yield put({
      type: Constants.COUPON_GET_COMPLETE,
      error: true
    })
  }
}

function * getAllCouponMoney ({ page, status, perPage }) {
  try {
    const { data } = yield call(
      service.getCouponsByType,
      'money',
      page,
      status,
      perPage
    )

    yield put(Actions.getMoneySuccess(data.data.vouchers))
  } catch (e) {
    yield put(Actions.getMoneyFailure(e.data))
  }
}

function * getAllCouponMoneyPaginated ({ page, status, perPage }) {
  try {
    const { data } = yield call(
      service.getCouponsByType,
      'money',
      page,
      status,
      perPage
    )

    yield put(Actions.getMoneyPaginatedSuccess(data.data.vouchers))
  } catch (e) {
    yield put(Actions.getMoneyPaginatedFailure(e.data))
  }
}

function * getAllCouponPercentage ({ page, status, perPage }) {
  try {
    const { data } = yield call(
      service.getCouponsByType,
      'advantages',
      page,
      status,
      perPage
    )

    yield put(Actions.getPercentageSuccess(data.data.vouchers))
  } catch (e) {
    yield put(Actions.getPercentageFailure(e.data))
  }
}

function * getAllCouponPercentagePaginated ({ page, status, perPage }) {
  try {
    const { data } = yield call(
      service.getCouponsByType,
      'advantages',
      page,
      status,
      perPage
    )

    yield put(Actions.getPercentagePaginatedSuccess(data.data.vouchers))
  } catch (e) {
    yield put(Actions.getPercentagePaginatedFailure(e.data))
  }
}

function * getAllCouponActivated ({ page, category, perPage }) {
  try {
    const { data } = yield call(
      service.getCouponsByType,
      category,
      page,
      'active',
      perPage
    )

    yield put(Actions.getActivatedSuccess(data.data.vouchers))
  } catch (e) {
    yield put(Actions.getActivatedFailure(e.data))
  }
}

function * activeById ({ id, category, active }) {
  try {
    yield call(service.setCouponActive, id, category, active)
    yield put(Actions.activeSuccess(id, category, { isActive: true }))
  } catch (e) {
    yield put(Actions.activeFailure(id, category, e.data))
  }
}

function * shareById ({ id, inhabitantId, callback }) {
  try {
    yield call(service.setShareCouponActive, id, inhabitantId)
    yield call(toast.success, 'Cupom compartilhado')
    yield call(callback)
    yield put(Actions.shareSuccess())
  } catch (e) {
    yield call(
      toast.error,
      'Não foi possível compartilhar esse cupom. Tente novamente mais tarde'
    )
    yield call(callback)
    yield put(Actions.shareFailure(e.data))
  }
}

export default function * root () {
  yield takeLatest(Constants.COUPON_GET, getById)
  yield takeEvery(Constants.COUPON_ACTIVE, activeById)
  yield takeLatest(Constants.COUPON_SHARE, shareById)
  yield takeLatest(Constants.COUPON_GET_MONEY, getAllCouponMoney)
  yield takeLatest(
    Constants.COUPON_GET_MONEY_PAGINATED,
    getAllCouponMoneyPaginated
  )
  yield takeLatest(Constants.COUPON_GET_PERCENTAGE, getAllCouponPercentage)
  yield takeLatest(
    Constants.COUPON_GET_PERCENTAGE_PAGINATED,
    getAllCouponPercentagePaginated
  )
  yield takeLatest(Constants.COUPON_GET_ACTIVATED, getAllCouponActivated)
  yield takeLatest(Constants.COUPON_ACTIVE_SUCCESS, getAllCouponActivated)
}
